/*istanbul ignore file*/
import { Handler } from "pagedjs";

interface PagedJsPage {
  position?: number;
  [key: string]: any; // Allows for other properties not explicitly defined
}

export class ReplaceFooterHandler extends Handler {
  public static footerText: string;

  afterPageLayout(pageFragment: DocumentFragment, page: PagedJsPage): void {
    // Check if the page contains an element with class 'skip-footer-text'
    const skipFooterElement = pageFragment.querySelector('.skip-footer-text');
    if (skipFooterElement) {
      return;
    }

    // Find the bottom-center box. Paged.js creates an element with class 'pagedjs_margin-bottom-center'
    const bottomCenterBox = pageFragment.querySelector('.pagedjs_margin-bottom-center');

    if (!bottomCenterBox) {
      console.warn("Paged.js: No .pagedjs_margin-bottom-center element found (in afterPageLayout - this is expected for some pages).");
      return;
    }

    // Clear existing content
    bottomCenterBox.innerHTML = '';

    // Create a new footerDiv
    const footerDiv = document.createElement('div');
    footerDiv.classList.add('super-footer');

    // Create left div (2/3 width)
    const leftDiv = document.createElement('div');
    leftDiv.classList.add('super-footer-left');

    const boldText = document.createElement('strong');
    boldText.textContent = ReplaceFooterHandler.footerText ;
    leftDiv.appendChild(boldText);
    leftDiv.appendChild(document.createElement('br'));
    
    // Get current date and format it in Dutch
    const currentDate = new Date();
    const months: string[] = [
      'januari', 'februari', 'maart', 'april', 'mei', 'juni',
      'juli', 'augustus', 'september', 'oktober', 'november', 'december'
    ];
    const monthIndex = currentDate.getMonth();
    const formattedDate = `${currentDate.getDate()} ${months[monthIndex]!} ${currentDate.getFullYear()}`;
    leftDiv.appendChild(document.createTextNode(formattedDate));

    // Create right div (1/3 width)
    const rightDiv = document.createElement('div');
    rightDiv.classList.add('super-footer-right');

    const boldAdviesrapport = document.createElement('strong');
    boldAdviesrapport.textContent = 'Adviesrapport';
    rightDiv.appendChild(boldAdviesrapport);
    rightDiv.appendChild(document.createElement('br'));
    const pageNumber = page.position !== undefined ? page.position + 1 : '';
    rightDiv.appendChild(document.createTextNode(`Pagina ${pageNumber}`));

    // Append left and right divs to footerDiv
    footerDiv.appendChild(leftDiv);
    footerDiv.appendChild(rightDiv);

    // Clearfix for floated elements
    const clearfix = document.createElement('div');
    clearfix.classList.add('super-footer-clearfix');
    footerDiv.appendChild(clearfix);
    
    bottomCenterBox.appendChild(footerDiv);
  }
}
